import React from 'react'
import { Layout, Showcase, Header } from '../../../../components'

import './style.scss'
import data from './data.json'
import changelog from '../../../../data/changelog.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      />
      <Layout
        category={data.category}
        description={data.description}
        changelog={changelog[data.title].changelog}
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
        updated={changelog[data.title].lastUpdated}
      >
        ## Values
        <Showcase
          site={data.site}
          switch={false}
          title=""
          text="Currency components have padding built in but for variants, use our predefined padding values to maintain consistent space throughout your designs. Use less space between small components, or components that share a functional relationship. Use more space between large components or components that are not functionally related."
          code={code.right}
        >
          <div class="full-width flex-column">
            <div class="padding-box l-padding--xxxsmall">
              <div class="padding-box__content c-text-content">
                2px - XXX Small
              </div>
            </div>
            <div class="padding-box l-padding--xxsmall">
              <div class="padding-box__content c-text-content">
                4px - XX Small
              </div>
            </div>
            <div class="padding-box l-padding--xsmall">
              <div class="padding-box__content c-text-content">
                8px - X Small
              </div>
            </div>
            <div class="padding-box l-padding--small">
              <div class="padding-box__content c-text-content">
                12px - Small
              </div>
            </div>
            <div class="padding-box l-padding--medium">
              <div class="padding-box__content c-text-content">
                16px - Medium
              </div>
            </div>
            <div class="padding-box l-padding--large">
              <div class="padding-box__content c-text-content">
                24px - Large
              </div>
            </div>
            <div class="padding-box l-padding--xlarge">
              <div class="padding-box__content c-text-content">
                32px - X Large
              </div>
            </div>
            <div class="padding-box l-padding--xxlarge">
              <div class="padding-box__content c-text-content">
                48px - XX Large
              </div>
            </div>
            <div class="padding-box l-padding--xxxlarge">
              <div class="padding-box__content c-text-content">
                64px - XXX Large
              </div>
            </div>
          </div>
        </Showcase>
      </Layout>
    </>
  )
}

export const code = {
  /*
  top: `<div class="l-padding-top--xxsmall"></div>
`,
  bottom: `<div class="l-padding-bottom--xxsmall"></div>
`,
  left: `<div class="l-padding-left--xxsmall"></div>
`,
  right: `<div class="l-padding-right--xxsmall"></div>
`,*/
}
